import { fileTxtIcon, homeIcon } from '@progress/kendo-svg-icons';
import { MenuItemModel } from '../../models/menu/menu-item.model';
import { MenuItems } from '../../models/menu/menu-items';

/* eslint-disable max-lines */
export const menuItemsConst: MenuItems = {
    parents: [
        {
            id: 'home',
            translation: 'menu.label.home',
            icon: homeIcon,
            routerLink: '/home',
            expanded: false,
            children: false,
            selected: true
        },
        {
            id: 'cf-document',
            translation: 'menu.label.cf-document',
            icon: fileTxtIcon,
            routerLink: '/cf-document',
            expanded: false,
            children: false,
            selected: false
        }
    ] as Array<MenuItemModel>
};
